import React from 'react'

import StringField from './StringField'
import { fieldPropsInterfaceItem } from './Types'

export default function TelField(props: fieldPropsInterfaceItem) {
  return <StringField {...props} keyboardType="phone-pad" />
}
